module.exports = __webpack_public_path__ + "img/20190923171739094.530609fd.jpg";